import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { ActionTypes } from '../../utils/enums';
import {
    getNextAction,
    buildConditionalActionsAnswerHistory
} from '../../utils/nextActionUtil';
import { isPortrait } from '../../utils/size';
import { isLongText } from '../../components/Shared/commonFunctions';
import { getActionCompletedTime } from '../../utils/actionTiming';
import {
    relevantRepresentatives,
    joinEnglish
} from '../../utils/localRepresentative/parser';

import {
    triggerFindYourRep,
    hideFindRepPopup,
    loadLocalRep,
    goToFindLocalRep,
    selectAction
} from '../LocalRep/actions';

import {
    onGoToNextCard,
    onGoToNextActionInsideCard,
    setOverlayPartnerVisible,
    setExitingCardProps,
    getExitingCardProps
} from '../Widget/actions';

import { initTweet, onCompleteTweet } from '../Tweet/actions';
import getTwitterShareUrl from '../../utils/tweet/tweetShare';

import LocalRepAction from '../../components/LocalRep/LocalRepAction';
import { AutoScalingButtonSet } from '../../components/Buttons/AutoScalingButtonSet';

import {
    SingleAction,
    parseSingleActionProps
} from '../SingleAction/SingleActionDetails';

class TweetStart extends SingleAction {
    tweetAndAdvanceToNextCard = activeAction => {
        window.open(
            getTwitterShareUrl(
                activeAction.text,
                this.props.localRepTwitterMention,
                this.props.localRepPostalCode,
                this.props.partnerName,
                this.props.publisherName,
                this.props.articleUrl,
                false,
                this.props.repState,
                this.props.repDistrict
            ),
            'popup',
            'height=350,width=600'
        );

        this.props.initTweet(this.props.apiRequestData, this.props.actionIdentifier);

        this.props.onCompleteTweet(
            this.props.apiRequestData,
            this.props.actionCompletedTime(),
            this.props.actionIdentifier,
            this.props.feedbackText,
            this.props.feedbackTitle,
            this.props.useLocalRepresentative,
            this.props.localRepresentativeState
        );

        if (this.props.nextAction) {
            this.props.onGoToNextCard(
                this.props.nextAction.identifier,
                this.props.nextCard.type,
                this.props.nextAction.type,
                this.props.nextAction.skipFrontCard ||
                    this.props.nextAction.scrollableDesign,
                false
            );
        }
    };

    buttonComponent() {
        return (
            <AutoScalingButtonSet>
                {this.props.actions.map(a => (
                    <LocalRepAction
                        isLongText={
                            !isPortrait() &&
                            isLongText(this.props.cardTitle, 40) &&
                            isLongText(this.props.cardDescription, 90)
                        }
                        action={a}
                        text={a.label}
                        key={a.identifier}
                        onClick={() => {
                            this.props.setExitingCardProps(
                                'tweet',
                                this.props,
                                this.props.activeAction
                            );

                            if (
                                this.props.activeAction.type === 'tweet' &&
                                (this.props.localRepFound || !a.useLocalRepresentative)
                            ) {
                                this.tweetAndAdvanceToNextCard(this.props.activeAction);
                            } else {
                                if (
                                    this.props.localRepFound ||
                                    !a.useLocalRepresentative
                                ) {
                                    this.props.selectAction(a.identifier);
                                    return this.props.onGoToNextActionInsideCard(
                                        a.identifier,
                                        a.type,
                                        true,
                                        false
                                    );
                                } else {
                                    this.props.selectAction(a.identifier);
                                    this.props.goToFindLocalRep(a.identifier, a.type);
                                }
                            }
                        }}
                    />
                ))}
            </AutoScalingButtonSet>
        );
    }
}
TweetStart.propTypes = {
    ...SingleAction.propTypes,
    actionCompletedTime: PropTypes.func.isRequired,
    actionIdentifier: PropTypes.string.isRequired,
    activeAction: PropTypes.object.isRequired,
    apiRequestData: PropTypes.object.isRequired,
    articleUrl: PropTypes.string,
    cardDescription: PropTypes.string.isRequired,
    cardTitle: PropTypes.string.isRequired,
    feedbackText: PropTypes.string.isRequired,
    feedbackTitle: PropTypes.string.isRequired,
    initTweet: PropTypes.func.isRequired,
    localRepPostalCode: PropTypes.string,
    localRepresentativeState: PropTypes.number,
    localRepTwitterMention: PropTypes.string,
    nextAction: PropTypes.object,
    nextCard: PropTypes.object,
    onCompleteTweet: PropTypes.func.isRequired,
    partnerName: PropTypes.string,
    publisherName: PropTypes.string,
    repDistrict: PropTypes.string,
    repState: PropTypes.string,
    setExitingCardProps: PropTypes.func.isRequired,
    useLocalRepresentative: PropTypes.bool.isRequired,
    completeRepStance: PropTypes.func,
    getRepStances: PropTypes.func,
    initiateRepStance: PropTypes.func,
    onBackWithinCard: PropTypes.func
};

export default connect(
    (state, props) => {
        const exitingProps = getExitingCardProps(
            'tweet',
            ['/tweet', '/tweet/start'],
            props.location.pathname,
            state
        );
        if (exitingProps) return exitingProps;

        const reps = state.localRep.localRepData
            ? relevantRepresentatives(
                  state.widget.activeAction.representativeSearch,
                  state.localRep.localRepData.representative
              ).slice(0, 3)
            : [];
        const nextAction = getNextAction(
            state.widget.actions,
            state.widget.activeAction.identifier,
            buildConditionalActionsAnswerHistory(state),
            state.widget.cards
        );
        return {
            ...parseSingleActionProps(state),
            activeAction: state.widget.activeAction,
            nextAction,
            nextCard: nextAction ? state.widget.cards[nextAction.order - 1] : null,
            actionCompletedTime: getActionCompletedTime(state, 'tweet'),
            apiRequestData: state.widget.apiRequestData,
            localRepTwitterMention: joinEnglish(
                reps.map(rep => {
                    if (rep.twitterMention && rep.twitterMention.length > 0) {
                        return '@' + rep.twitterMention;
                    }
                    return rep.fullName;
                })
            ),
            localRepPostalCode: (state.localRep.localRepData.address || {}).zipCode,
            partnerName:
                state.widget.activeAction.partner !== undefined
                    ? state.widget.activeAction.partner.twitterMention !== undefined
                        ? '@' + state.widget.activeAction.partner.twitterMention
                        : state.widget.activeAction.partner.name
                    : 'Speakable',
            publisherName:
                state.widget.twitterMention !== undefined
                    ? '@' + state.widget.twitterMention
                    : state.widget.publisherName,
            articleUrl: state.widget.articleUrl,
            actionIdentifier: state.widget.activeAction.identifier,
            feedbackText:
                state.widget.activeAction.thankYouText || 'Make your voice heard!',
            feedbackTitle: state.widget.activeAction.thankYouTitle || 'Speak Up',
            localRepresentativeState: state.widget.activeAction.localRepresentativeState
        };
    },
    {
        triggerFindYourRep,
        hideFindRepPopup,
        loadLocalRep,
        onGoToNextCard,
        onGoToNextActionInsideCard,
        goToFindLocalRep,
        setExitingCardProps,
        setOverlayPartnerVisible,
        selectAction,
        initTweet,
        onCompleteTweet
    },
    null,
    {
        areStatesEqual: (next, prev) => {
            if (next.widget.activeAction.type !== ActionTypes.Tweet) return true;

            return next === prev;
        }
    }
)(TweetStart);
